import * as globalTypes from "@/store/mutation-types";
import icons from "@/mixins/icons.js";
import basicOperations from "@/mixins/basic-operations";
import RSM from "wisaapp-webstudent/src/mixins/right-side-menu.js";
import tab from "@/components/utils/tab/tab.vue";
import ValidationService from "@/services/validation.service.js";
import DropdownInPlace from "@/components/utils/dropdown-in-place/dropdown-in-place.vue";
const axios = require('axios');
import globalStore from "@/store/index.js";
import * as types from "wisaapp-webstudent/src/store/mutation-types";

const validationService = new ValidationService();
//  const basicOperations = require('@/mixins/basic-operations.js')

import Vue from "vue";
export default {
  name: "LoginComponent",
  mixins: [basicOperations, icons, RSM],
  components: {
    tab,
    DropdownInPlace
  },
  data() {
    let self = this;
    return {
      API: null,
      welcomeMessage: "Welkom gebruiker",
      msg: "To Do Lis t should bee shown below",
      alertDuration: 1000,
      givenText: "aAa",
      showConnectionList: true,
      toBeConnectedConnectionObject: {},

      editMode: false,
      connectionTypes: JSON.parse(JSON.stringify(self.$store.state.allConnectionTypes)),
      connectionObject: {
        connectionName: "",
        serverLocation: "",
        username: "",
        password: "",
        rememberMe: true,
        ID: ""
      },
      isMobile: this.$store.state.isMobile,
      passwordFieldType: 'password',
      Office365LoginAllowed: false,
      GoogleLoginAllowed: false,
      FaceBookLoginAllowed: false

    };
  },

  computed: {


    existingConnections() {
      return this.$store.state.listOfConnections;
    },
    backButtonVisible() {
      return !this.showConnectionList;
    }
  },
  created() {
    let path = window.location;
    let origin = path.origin;
    let pathname = path.pathname;
    let arrayPathname = pathname.split("/");
    //production
    let index = ''
    if (arrayPathname.length > 0) {

      index = arrayPathname.indexOf("webstudent");
    }
    if (index === -1 || index === '-1') {
      this.connectionObject.serverLocation = origin
    } else {
      this.connectionObject.serverLocation = origin + '/webstudent'
    }

    // dev:
    // this.connectionObject.serverLocation = "http://localhost/webstudent/";
    // this.connectionObject.serverLocation = "https://9db9b0e699fe.ngrok.io/webstudent/";
       
axios.get( this.connectionObject.serverLocation+'/bin/server.fcgi/RPC/API').then(resp => {
  this.API = eval(resp.data)
}); 

    this.$store.commit("wstudent/" + types.ZET_CURRENT_SCREEN, "login");

    this.$store.commit(globalTypes.SET_MENUBAR_ITEMS, {
      left: [],
      title: this.$store.state.projectNaam,
      right: []
    });
    if (
      typeof this.$store.state.userInfo.loggedInUserInformation !== "undefined" &&
      this.$store.state.userInfo.loggedInUserInformation !== null &&
      typeof this.$store.state.userInfo.loggedInUserInformation.UserData !== "undefined"
    ) {
      //  this.$store.dispatch('logout')
    }
    this.add();
    console.log(this.$route)
    if(!(Object.keys(this.$route.query).length === 0)  ){
     let credentials = this.$route.query.un.split('/pw=')
     this.connectionObject.username=credentials[0]
     this.connectionObject.password=credentials[1]
     this.connect(this.connectionObject)
   
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    let self = this;


    this.$store.dispatch('apiCheck', {
      dezeDit: this,
      succesCallback: this.initApiCheckComplete
    })
    // $(this.$refs.vuemodal).on("hidden.bs.modal", this.closeModal);
    setTimeout(function () {
      if (
        self.$store.state.listOfConnections.length === 1 /* when there is just 1 connection */ &&
        !self.$store.state.userInfo.loggedOutOnce /* when user never logged out yet */
      ) {
        self.connectionObjectClicked(self.existingConnections[0]);
      }
    }, 100);

  },
  methods: {
    openOfficeUrl(){
      window.location =(this.connectionObject.serverLocation + '/bin/server.fcgi/oauth2/login/office365?webstudent')
    },
    getUsername() {
      this.$router.push("/mijn-gebruiker/gebruiker-username/");
    },
    initApiCheckComplete() {
      this.Office365LoginAllowed = this.$store.state.api.Office365Login
      this.GoogleLoginAllowed = this.$store.state.api.GoogleLogin
      this.FaceBookLoginAllowed = this.$store.state.api.FaceBookLogin
    },

    createaccount() {
      // this.arrangeModuleFlags('Info')

      if (this.API === null) {
        this.$store.dispatch('apiCheck', {
          dezeDit: this,
          succesCallback: this.createAccountVervolg
        })
      } else {
        this.createAccountVervolg()
      }


    },
    createAccountVervolg() {
      this._goTo('mijn-gebruiker/gebruiker-aanmaken')
    },

    connectionObjectClicked(connectionObject) {
      if (connectionObject.rememberMe) {
        this.connect(connectionObject);
      } else {
        this.toBeConnectedConnectionObject = Vue.util.extend({}, connectionObject);
        this.toBeConnectedConnectionObject.password = "";
        this.goToLoginWithPasswordTab();
      }
    },
    LoadGlobalDataBeforeComponentsLoad() {
      let self = this
      self.$store.dispatch("wstudent/" + "getLeerling").then(result => {
        self.$store.dispatch("wstudent/" + "getCursistInfo", [result[0].ID]).then(result => {

        })

        self.$store.dispatch("wstudent/" + "getParticipation", [result[0].ID]).then(result => {
          self._goTo("landing-page");
        })
      })
    },
    connect(conn) {
      if (!this.$store.state.flags.loginProcedureLocked) {
        this.$store.commit(globalTypes.ADD_CONNECTION_TO_LIST_OF_CONNECTIONS, this);
        // this.$store.commit(globalTypes.SHOW_MESSAGE, 'Connectie is toegevoegd')
        this.$store.commit(globalTypes.LOCK_LOGIN_PROCEDURE);
        let self = this;
        this.$store.dispatch({
          type: "login",
          connection: conn,
          API: "REST",
          successCallback: function (res) {


            self.$store.commit(globalTypes.UNLOCK_LOGIN_PROCEDURE);
            if (res.data.error === null) {
              self.$store.commit(globalTypes.SET_LOGIN_REDIRECTED, true);
              if (res.data.result.UserData.veranderpaswoord) {
                self._goTo('mijn-gebruiker/wachtwoord-wijzigen')

                // eslint-disable-next-line no-undef
              } else if (WISA.ClientConf.BlockAccountCreation && res.data.result.UserData.name !== 'Beheerder') {

                self.$store.commit(globalTypes.SHOW_MESSAGE, ['Fout bij aanmelden: Gebruiker geblokkeerd', 'long'])
                // setTimeout(function() {
                //   // window.location.href = window.location.href.split('/vue/')[0] + '/mijn-gegevens.html'
                //   // self.$router.push('/') 

                // }, 3000)
                // alert("Kan scherm /'loginveranderpaswoord/' niet openen. Geen toestemming om scherm te openen. Gelieve uw systeembeheerder te contracteren");
                // $("#errorMessage").modal("show");
                // self.modals.warningModalOpen=true
                // $("#changepassword").modal("show")
              }

              else {
                self.LoadGlobalDataBeforeComponentsLoad()

              }
            } else {
              self.$store.commit(globalTypes.SHOW_MESSAGE, res.data.error.message);
            }
          },
          failureCallback: function (res) {
            self.$store.commit(globalTypes.UNLOCK_LOGIN_PROCEDURE);
            self.$store.commit(globalTypes.SHOW_MESSAGE, res.message);
          }
        });
      }
    },
    add() {
      if (this.isFormValid()) {
        this.pasteSelectedConnectionTypeToConnectionObject();
        this.$store.commit(globalTypes.ADD_CONNECTION_TO_LIST_OF_CONNECTIONS, this);
        this.$store.commit(globalTypes.SHOW_MESSAGE, "Connectie is toegevoegd");
        // this._goBack()
      } else {
        // this.showFormErrorMessage()
      }
    },
    pasteSelectedConnectionTypeToConnectionObject() {
      this.connectionObject.connectionType = this.connectionTypes.filter(function (ct) {
        return ct._selected;
      })[0];
    },
    addNewConnection() {
      this.$store.commit(globalTypes.SET_MENUBAR_ITEMS, {
        left: "back",
        title: "Connectie toevoegen",
        right: []
      });
      this._goTo("/connection/new");
    },
    isFormValid() {
      return (
        validationService.isConnectionName(this.connectionObject.connectionName)[0] &&
        validationService.isUsername(this.connectionObject.username)[0] &&
        validationService.isServerLocation(this.connectionObject.serverLocation)[0] &&
        (!this.connectionObject.rememberMe || validationService.isPassword(this.connectionObject.password)[0])
      );
    },
    changeConnection(connection, event) {
      this.$store.commit(globalTypes.SET_MENUBAR_ITEMS, {
        left: "back",
        title: "Connectie", // wijzigen
        right: []
      });
      this._goTo("/connection/" + connection.ID + "/edit");
    },
    goToLoginWithPasswordTab() {
      this.$store.commit(globalTypes.SET_MENUBAR_ITEMS, {
        left: [
          {
            ICON: this.icons.ARROW_LEFT,
            FUNCTIE: this.goBackToShowConnectionList
          }
        ],
        title: "Inloggen - " + this.toBeConnectedConnectionObject.connectionName,
        right: []
      });
      this.showConnectionList = false;
    },
    goBackToShowConnectionList() {
      this.$store.commit(globalTypes.SET_MENUBAR_ITEMS, {
        left: [],
        title: this.$store.state.projectNaam,
        right: []
      });
      this.showConnectionList = true;
    }
  },
  watch: {
    API: function (val, oldval) {
      this.Office365LoginAllowed = val.Office365Login
      this.GoogleLoginAllowed =val.GoogleLogin
      this.FaceBookLoginAllowed =val.FaceBookLogin
   this.$forceUpdate()
  
  }
  }
};
